// extracted by mini-css-extract-plugin
module.exports = {"AcceptedPaymentsLogos":"AcceptedPayments_AcceptedPaymentsLogos__s3xn5"};